// UPDRS 3 fields to be included when calculating the score
export const updrsFields: (keyof IUPDRSIII)[] = [
  'speechUpdrs',
  'facialExpressionUpdrs',
  'restTremorFace',
  'restTremorRightHand',
  'restTremorLeftHand',
  'restTremorRightLeg',
  'restTremorLeftLeg',
  'actionPosturalTremorRightHand',
  'actionPosturalTremorLeftHand',
  'rigidityNeckUpdrs',
  'rigidityRightHand',
  'rigidityLeftHand',
  'rigidityRightLeg',
  'rigidityLeftLeg',
  'fingerTapsRight',
  'fingerTapsLeft',
  'handMovementsRightUpdrs',
  'handMovementsLeftUpdrs',
  'pronationSupinationRightUpdrs',
  'pronationSupinationLeftUpdrs',
  'legAgilityRightUpdrs',
  'legAgilityLeftUpdrs',
  'arisingFromChairUpdrs',
  'postureUpdrs',
  'walking',
  'balance',
  'bradykinesiaHypokinesia',
];

// MDS UPDRS fields to be included when calculating the score
export const mdsUPDRSFields: (keyof IUPDRSIII)[] = [
  'speech',
  'facialExpression',
  'rigidityNeck',
  'rigidityRUE',
  'rigidityLUE',
  'rigidityRLE',
  'rigidityLLE',
  'fingerTappingRight',
  'fingerTappingLeft',
  'handMovementsRight',
  'handMovementsLeft',
  'pronationSupinationRight',
  'pronationSupinationLeft',
  'toeTappingRight',
  'toeTappingLeft',
  'legAgilityRight',
  'legAgilityLeft',
  'arisingFromChair',
  'gait',
  'freezingOfGait',
  'posturalStability',
  'posture',
  'globalSpontaneityOfMovement',
  'posturalTremorOfHandsRight',
  'posturalTremorOfHandsLeft',
  'kineticTremorOfHandsRight',
  'kineticTremorOfHandsLeft',
  'restTremorAmplitudeRUE',
  'restTremorAmplitudeLUE',
  'restTremorAmplitudeRLE',
  'restTremorAmplitudeLLE',
  'restTremorAmplitudeLipJaw',
  'constancyOfRestTremor',
];
